import { render, staticRenderFns } from "./SwatchList.vue?vue&type=template&id=561a8b95&scoped=true&"
import script from "./SwatchList.vue?vue&type=script&lang=js&"
export * from "./SwatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a8b95",
  null
  
)

export default component.exports